var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5753 13.389H28.5013V13.3337H16.5013V18.667H24.0366C22.9373 21.7717 19.9833 24.0003 16.5013 24.0003C12.0833 24.0003 8.5013 20.4183 8.5013 16.0003C8.5013 11.5823 12.0833 8.00033 16.5013 8.00033C18.5406 8.00033 20.396 8.76966 21.8086 10.0263L25.58 6.25499C23.1986 4.03566 20.0133 2.66699 16.5013 2.66699C9.13797 2.66699 3.16797 8.63699 3.16797 16.0003C3.16797 23.3637 9.13797 29.3337 16.5013 29.3337C23.8646 29.3337 29.8346 23.3637 29.8346 16.0003C29.8346 15.1063 29.7426 14.2337 29.5753 13.389Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70312 9.79433L9.08379 13.007C10.2691 10.0723 13.1398 8.00033 16.4991 8.00033C18.5385 8.00033 20.3938 8.76966 21.8065 10.0263L25.5778 6.25499C23.1965 4.03566 20.0111 2.66699 16.4991 2.66699C11.3778 2.66699 6.93646 5.55833 4.70312 9.79433Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4989 29.3338C19.9429 29.3338 23.0722 28.0158 25.4382 25.8725L21.3116 22.3805C19.9279 23.4327 18.2372 24.0018 16.4989 24.0005C13.0309 24.0005 10.0862 21.7891 8.97691 18.7031L4.62891 22.0531C6.83557 26.3711 11.3169 29.3338 16.4989 29.3338Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.574 13.3883H28.5V13.333H16.5V18.6663H24.0353C23.5095 20.1439 22.5622 21.4351 21.3107 22.3803L21.3127 22.379L25.4393 25.871C25.1473 26.1363 29.8333 22.6663 29.8333 15.9997C29.8333 15.1057 29.7413 14.233 29.574 13.3883Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.c983667f6d77d8d99c824faa95fd727b.svg";
export { ForwardRef as ReactComponent };